<template>
  <div class="keyword">
    <!-- 关键词 -->
    <div class="keyword-top">
      <span>
        <img src="../../assets/img/home-icon.png" alt="" class="home-icon-img">
        <router-link :to="{ name: 'home' }">首页</router-link>
      </span>&nbsp;/&nbsp;
      <span>
        <router-link :to="{ name: 'product' }">产品管理</router-link>
      </span>&nbsp;/&nbsp;
      <span>
        {{ pname }} >关键词
      </span>
      <el-button icon="el-icon-back" class="retrunbtn" type="text" @click="urlback" v-if="pid > 0">返回</el-button>
    </div>
    <div class="keyword-content material-list">
      <div class="keyword-content-search">
        <!-- <el-button class="keyword-return-btn" @click="urlback">返回</el-button> -->
      </div>
      <!--  -->
      <div class="keyword-content-box">
        <div class="keyword-content-box-top">
          <div class="keyword-content-box-top-left">
            <div class="keyword-box-img-box">
              <img src="../../assets/img/keyword-icon1.png" alt="">
            </div>
            <span>关键词</span>
          </div>
          <el-button class="keyword-random-btn" @click="kw_Handle" icon="el-icon-cpu">
            <!-- <img src="../../assets/img/random-icon.png" alt=""> -->
            AI推荐
          </el-button>
        </div>
        <el-input placeholder="请输入关键词,多个关键词用回车键Enter隔开" v-model="keywordVla" @keyup.enter.native="addkw(1)"></el-input>
        <div class="keyword-produce">
          <span class="keyword-produce-item" v-for="item in kws">
            {{ item.content }}
            <span>
              <i class="el-icon-close" @click="delkw(item)"></i>
            </span>
          </span>

        </div>
      </div>
      <div class="keyword-content-box">
        <div class="keyword-content-box-top">
          <div class="keyword-content-box-top-left">
            <div class="keyword-box-img-box">
              <img src="../../assets/img/keyword-icon1.png" alt="">
            </div>
            <span>长尾词</span>
          </div>
          <el-button class="keyword-random-btn" @click="longkw_Handle" icon="el-icon-cpu">
            <!-- <img src="../../assets/img/random-icon.png" alt=""> -->
            AI推荐
          </el-button>
        </div>
        <el-input placeholder="请输入长尾词,多个长尾词用回车键Enter隔开" v-model="longTailVal" @keyup.enter.native="addkw(2)"></el-input>
        <div class="keyword-produce">
          <span class="keyword-produce-item" v-for="item in longkws">
            {{ item.content }}
            <span>
              <i class="el-icon-close" @click="delkw(item)"></i>
            </span>
          </span>
        </div>
      </div>

      <div class="keyword-content-box">
        <div class="keyword-content-box-top">
          <div class="keyword-content-box-top-left">
            <div class="keyword-box-img-box">
              <img src="../../assets/img/keyword-icon1.png" alt="">
            </div>
            <span>城市</span>
          </div>
        </div>
        <el-input placeholder="请输入城市,多个城市用回车键Enter隔开" v-model="cityVal" @keyup.enter.native="addkw(3)"></el-input>
        <div class="keyword-produce">
          <span class="keyword-produce-item" v-for="item in citykws">
            {{ item.content }}
            <span>
              <i class="el-icon-close" @click="delkw(item)"></i>
            </span>
          </span>
        </div>
      </div>
    </div>
    <!-- 弹框 -->
    <div>
      <el-dialog title="关键词推荐列表" class="keyword-dialog" width="450px" :visible.sync="kw_dialog"
        :close-on-click-modal="false">
        <el-table ref="kw_ref" style="width: 100%" :data="kw_data" @selection-change="kw_Select"
          :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: 'bold' }"
          v-loading="kw_loading" height="485">
          <el-table-column label="关键词">
            <template slot-scope="scope"> {{ scope.row }}</template>
          </el-table-column>
          <el-table-column type="selection" align="center">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="kw_Refresh" class="dialog-footer-btn dialog-footer-cancel"
            icon="el-icon-refresh">换一批</el-button>
          <el-button @click="kw_dialog = false" class="dialog-footer-btn dialog-footer-cancel">取 消</el-button>
          <el-button type="primary" @click="kw_Ok" class="dialog-footer-btn dialog-footer-confirm">确
            定</el-button>
        </span>
      </el-dialog>
    </div>

    <div>
      <el-dialog title="长尾词推荐列表" class="keyword-dialog" width="450px" :visible.sync="longkw_dialog"
        :close-on-click-modal="false">
        <el-table ref="longkw_ref" style="width: 100%" :data="longkw_data" @selection-change="longkw_Select"
          :header-cell-style="{ backgroundColor: '#f1f1f1', color: '#000', fontSize: '14px', fontWeight: 'bold' }"
          v-loading="longkw_loading" height="485">
          <el-table-column label="关键词">
            <template slot-scope="scope"> {{ scope.row }}</template>
          </el-table-column>
          <el-table-column type="selection" align="center">
          </el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
          <el-button @click="longkw_Refresh" class="dialog-footer-btn dialog-footer-cancel"
            icon="el-icon-refresh">换一批</el-button>
          <el-button @click="longkw_dialog = false" class="dialog-footer-btn dialog-footer-cancel">取 消</el-button>
          <el-button type="primary" @click="kw_Ok" class="dialog-footer-btn dialog-footer-confirm">确
            定</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import { creation_kw } from '../../assets/js/creation'
export default {
  name: 'keywordPage',
  data() {
    return {
      // 关键词
      keywordVla: '',
      // 长尾词
      longTailVal: '',
      //城市词
      cityVal: '',
      pname: '',
      pid: 0,
      kws: [],
      longkws: [],
      citykws: [],

      kw_dialog: false,
      kw_data: null,
      kw_loading: false,
      kw_adds: [],

      longkw_dialog: false,
      longkw_data: null,
      longkw_loading: false,
    }
  },
  created() {
    var query = this.$route.query;
    this.pname = query.name;
    this.pid = query.pid;
    this.listkw();
  },
  methods: {
    urlback() {
      this.$router.go(-1);
    },
    //ai关键词
    kw_Handle() {
      this.kw_dialog = true;
      if (this.kw_data != null) return;
      this.kw_loading = true;
      this.$get('/ai/creation_kw', { q: this.pname }).then(res => {
        if (res.code == 200) {
          this.kw_data = res.data;
          this.$nextTick(() => {
            this.kw_data.forEach(row => {
              this.$refs.kw_ref.toggleRowSelection(row, true);
            });
          });
        }
      }).finally(res => {
        this.kw_loading = false;
      })

    },
    kw_Select(v) {
      this.kw_adds = [];
      v.forEach(item => {
        this.kw_adds.push({ content: item, type: 1 })
      });
    },
    kw_Refresh() {
      this.kw_data = null
      this.kw_Handle();
    },
    //ai长尾词
    longkw_Handle() {
      this.longkw_dialog = true;
      if (this.longkw_data != null) return;
      this.longkw_loading = true;
      this.$get('/ai/creation_kw', { q: this.pname, ismain: false }).then(res => {
        if (res.code == 200) {
          this.longkw_data = res.data;
          this.$nextTick(() => {
            this.longkw_data.forEach(row => {
              this.$refs.longkw_ref.toggleRowSelection(row, true);
            });
          });
        }
      }).finally(res => {
        this.longkw_loading = false;
      })
    },
    longkw_Select(v) {
      this.kw_adds = [];
      v.forEach(item => {
        this.kw_adds.push({ content: item, type: 2 })
      });
    },
    longkw_Refresh() {
      this.longkw_data = null
      this.longkw_Handle();
    },

    //批量添加
    kw_Ok() {
      this.$post('/kw/add', {
        item: this.kw_adds,
        product_id: this.pid
      }).then(res => {
        if (res.code == 200) {
          this.keywordVla = '';
          this.longTailVal = '';
          this.$message.success('添加完成');
          this.kw_dialog = false;
          this.longkw_dialog = false;
          this.listkw();
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    //单个添加
    addkw(type) {
      var text = "";
      switch (type) {
        case 1:
          text = this.keywordVla;
          break;
        case 2:
          text = this.longTailVal;
          break;
        case 3:
          text = this.cityVal;
          break;
      }
      if (text == '') return;
      var p = [{ content: text, type: type }];

      this.$post('/kw/add', {
        item: p,
        product_id: this.pid
      }).then(res => {
        if (res.code == 200) {
          this.keywordVla = '';
          this.longTailVal = '';
          this.cityVal = '';
          this.$message.success('添加完成');
          this.listkw();
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    listkw() {
      this.$get('/kw/list', { product_id: this.pid, type: 1 }).then(res => {
        this.kws = res.data;
      })
      this.$get('/kw/list', { product_id: this.pid, type: 2 }).then(res => {
        this.longkws = res.data;
      })
      this.$get('/kw/list', { product_id: this.pid, type: 3 }).then(res => {
        this.citykws = res.data;
      })
    },
    delkw(row) {
      this.$post('/kw/del', { keyword_id: row.keyword_id }).then(res => {
        if (res.code == 200) {
          this.$message.success('删除完成');
          this.listkw();
        } else {
          this.$message.error(res.msg);
        }
      })
    },
  },
}
</script>
<style scoped>
.keyword {
  height: 100%;
}

.keyword-top {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 3px;
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 16px 20px;
}

.keyword-top {
  color: #606266;
  font-size: 14px;
}

.keyword-top .home-icon-img {
  margin-right: 4px;
}

.keyword-top a {
  color: #606266;
}

.keyword-top a:hover {
  color: #006cff;
}

.keyword-content {
  background-color: #fff;
  box-sizing: border-box;
  padding: 0 20px;
  position: relative;
  height: calc(100vh - 150px);
}

.keyword-content-search {
  box-sizing: border-box;
  padding: 16px 0;
  border-bottom: 1px dotted #e5e5e5;
}

.keyword-name-sear {
  width: 278px;
  height: 40px;
  margin-right: 16px;
}

.keyword-search-title {
  font-size: 14px;
  color: #333;
}

.product-name-sear input {
  background-color: #fff;
  border: 1px solid #d9dde5;
  border-radius: 3px;
}

.keyword-relevancy {
  width: 278px;
  height: 40px;
  margin-right: 16px;
  margin-left: 4px;
}

.keyword-search-btn {
  width: 88px;
  height: 40px;
  background-color: #006cff;
  border-radius: 3px;
  color: #fff;
  border: none;
  opacity: 1;
  transition: all 0.2s linear;
}

.keyword-search-btn:hover {
  opacity: 0.9;
}

.keyword-return-btn {
  width: 88px;
  height: 40px;
  background-color: #fff;
  border: 1px solid #d9dde5;
  border-radius: 3px;
  color: #565656;
  font-size: 14px;
  opacity: 1;
  transition: all 0.2s linear;
}

.keyword-return-btn:hover {
  opacity: 0.9;
}

.keyword-content-box {
  background-color: #f5f6fa;
  border: 1px solid #f0f0f1;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 20px 30px;
  margin-bottom: 30px;
}

/*  */
.keyword-content-box-top-left {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}

.keyword-content-box-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.keyword-box-img-box {
  width: 39px;
  height: 39px;
  background-color: #006cff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 13px;
}

.keyword-hint-box {
  position: relative;
  margin-left: 7px;
}

.keyword-hint {
  width: 234px;
  height: 36px;
  background-color: #fff;
  box-shadow: 1px 2px 10px 0px rgba(198, 198, 198, 0.39);
  border-radius: 5px;
  position: absolute;
  top: -13px;
  left: 28px;
  font-size: 14px;
  color: #565656;
  box-sizing: border-box;
  padding: 10px 20px;
}

.keyword-hint::after {
  content: '';
  width: 0;
  height: 0;
  border: 5px solid rgba(0, 0, 0, 0);
  border-right: 5px solid #fff;
  position: absolute;
  left: -9px;
  top: 12px;
  box-shadow: 1px 2px 10px 0px rgba(198, 198, 198, 0.39);
}

.keyword-random-btn {
  width: 100px;
  height: 36px;
  background-color: #006cff !important;
  border-radius: 5px;
  padding: 0;
  color: #fff !important;
  font-size: 14px;
  opacity: 1;
  transition: all 0.2s linear;
}

.keyword-random-btn:hover {
  opacity: 0.9;
}

.keyword-produce {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
}

.keyword-produce-item {
  display: block;
  background-color: #e6f0ff;
  border: 1px solid #99c4ff;
  border-radius: 5px;
  font-size: 14px;
  color: #333;
  box-sizing: border-box;
  padding: 10px 15px;
  position: relative;
}

.keyword-produce-item span {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #ea5152;
  position: absolute;
  font-size: 12px;
  color: #fff;
  top: -8px;
  right: -8px;
  opacity: 0;
  transition: all 0.2s linear;
  cursor: pointer;
}

.keyword-produce-item:hover span {
  opacity: 1;
}

/*  */
.keyword-bottom {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 30px;
  left: 14%;
}

.keyword-bottom .el-pagination {
  color: #606266;
  font-weight: 400;
}

.keyword-bottom .el-pagination>>>button {
  border: 1px solid #d9d9d9 !important;
  border-radius: 3px;
  padding: 0;
  min-width: 28px !important;
}

.keyword-bottom .el-pagination .btn-next,
.el-pagination .btn-prev {
  background: center center no-repeat #FFF;
  background-size: 16px;
  cursor: pointer;
  margin: 0;
  color: #606266;
}

.keyword-bottom .el-pagination .el-select .el-input {
  width: 90px;
  margin: 0 5px;
}

.keyword-bottom .el-pagination>>>.el-pagination__jump {
  margin-left: 10px;
  font-weight: 400;
  color: #606266;
}

.keyword-bottom-left {
  margin-left: 14px;
}

.keyword-bottom-left>>>.el-checkbox__label {
  padding-left: 20px;
}

.keyword-dialog>>>.el-table__cell {
  padding: 14px 0;
}

.keyword-dialog>>>.el-dialog__title {
  font-size: 15px;
  color: #333;
  font-weight: bold;
}

.keyword-dialog>>>.el-dialog__header {
  padding: 10px 18px;
  border-bottom: 1px solid #eee;
}

.keyword-dialog>>>.el-dialog__body {
  padding-top: 17px;
  height: 485;
  overflow-y: auto;
}

.keyword-dialog>>>.el-checkbox__inner {
  border-radius: 50%;
  border: 1px solid #D3D3D3;
  background-color: #fff;
}

.keyword-dialog>>>.el-checkbox__input.is-checked .el-checkbox__inner {
  border: 1px solid #006CFF;
}

.keyword-dialog>>>.el-checkbox__inner::after {
  width: 8px;
  height: 8px;
  background-color: #006cff;
  border-radius: 50%;
  left: 2px;
  top: 2px;
}

.keyword-dialog>>>.el-dialog__headerbtn {
  position: absolute;
  top: 13px;
  right: 20px;
  padding: 0;
  background: 0 0;
  border: none;
  outline: 0;
  cursor: pointer;
  font-size: 16px;
}

.keyword-dialog>>>.el-table__cell {
  padding: 10px 0;
}

.dialog-footer-btn {
  width: 74px;
  height: 36px;
  padding: 0;
  border-radius: 3px;
}

.dialog-footer-cancel {
  border: 1px solid #d9dde5;
  background-color: rgba(235, 240, 246, 0);
  font-size: 14px;
  color: #606266;
}

.dialog-footer-confirm {
  background-color: #006CFF;
  font-size: 14px;
  color: #fff;
}

.keyword-dialog>>>.el-dialog__footer {
  border-top: 1px solid #eee;
  padding-top: 18px;
  padding-bottom: 16px;
  /* margin-top: 40px; */
}

.keyword-dialog>>>.el-dialog__body::-webkit-scrollbar {
  width: 20px;
}

.keyword-dialog>>>.el-dialog__body::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(138, 144, 153);
  border: 7px solid rgba(0, 0, 0, 0);
  box-shadow: 7px 0 0 #8A9099 inset;
}

.keyword-dialog>>>.el-dialog__body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  border-radius: 0;
  background: #fff;
}

@media screen and (max-width:1024px) {
  .keyword-search-btn {
    margin-top: 10px;
  }

  .keyword-return-btn {
    margin-top: 10px;
  }
}
</style>